export default {
  "user-sign-up": "User Sign Up",
  "please-fill-your-data": "Fill in the following data to create a ",
  "dr-now": "Dr Now account.",
  names: "Names",
  "names-placeholder": "Enter your names",
  "enter-two-or-more-names": "Add if you have two or more names.",
  "first-surname": "First Surname",
  "surname-placeholder": "Enter your first surname",
  "enter-your-first-surname": "Enter your first surname",
  "second-surname": "Second Surname",
  "enter-your-second-surname": "Enter your second surname",
  email: "Email",
  "email-placeholder": "Enter your email",
  "enter-your-work-email": "Add your email",
  "country-code": "Code",
  country: "Country",
  "phone-number": "Number",
  "phone-number-placeholder": "Enter your phone number",
  "enter-your-phone-number": "Contact number",
  password: "Password",
  "password-placeholder": "Enter a safe password",
  "enter-a-safe-password-msg": "To ensure the security of your account, create a password.",
  "at-least-eight-characters": "Minimum of 8 characters",
  "at-least-one-capital-letter": "At least one capital letter",
  "at-least-one-number": "At least one number",
  "at-least-one-special-character": "At least one special character",
  "password-confirmation": "Confirm Password",
  "password-confirmation-placeholder": "Enter the password again",
  "password-confirmation-msg": "Verify that your password matches",
  "read-and-accept": "I have read and accept",
  "terms-and-conditions": "Terms and Conditions, Privacy Policy",
  "marketing-notifications-agree": "I agree to receive marketing notifications",
  optional: "optional",
  "previous-fields-are-mandatory": "These fields are mandatory",
  continue: "Sign Up",
  accept: "Accept",
  "field-required": "Field required",
  "invalid-email": "Invalid email",
  "invalid-phone-number": "Invalid phone number",
  "invalid-characters": "Invalid characters",
  "invalid-password": "Invalid password",
  "passwords-must-match": "Passwords must match",
  "service-error": "Service error",
  "please-try-again-later": "Please, try again later",
  processing: "Processing",
  "sign-up-completed-message": "Thank you for signing up.",
  "go-to-home": "Go to home",
  "dr-now-doctor-sign-up-email-registered-title": "Registration error",
  "dr-now-doctor-sign-up-email-registered-message": "The email has already been registered",
  "valid-country-code": "Enter a valid country code",
};
